import React from "react";
import { Box, CircularProgress } from "@mui/material";

export interface LoadingOverlayProps { open: boolean; top?:string; left?:string; width?:string; height?:string; }
export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ open, top, left, width, height }) => {
    return open ? (
        <Box
          sx={{
            position: 'absolute',
            top: top || 0,
            left: left || 0,
            width: width || '100%',
            height: height || '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1,
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
    ) : null;
};